import { render, staticRenderFns } from "./colorSet.vue?vue&type=template&id=43680e68&"
import script from "./colorSet.vue?vue&type=script&lang=js&"
export * from "./colorSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports